import { render, staticRenderFns } from "./ConflictCommentEditor.vue?vue&type=template&id=788192ba&scoped=true&"
import script from "./ConflictCommentEditor.vue?vue&type=script&lang=ts&"
export * from "./ConflictCommentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ConflictCommentEditor.vue?vue&type=style&index=0&id=788192ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788192ba",
  null
  
)

export default component.exports